import * as Yup from 'yup';
import { ValidationErrorMessages } from './errors';

export const fidelityValidator = Yup.object().shape({
  nome: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  ragioneSociale: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  partitaIva: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  telefono: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  telefonoSecondario: Yup.string().nullable(true),
  sito: Yup.string().nullable(true).url('Formato URL non valido'),
  email: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED)
    .email(ValidationErrorMessages.EMAIL),
  sezione: Yup.number()
    .typeError('Seleziona una sezione')
    .nullable(true)
    .required(ValidationErrorMessages.REQUIRED),
  indirizzo: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  cap: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED)
    .matches(/^\d{5}$/, 'CAP deve essere di 5 cifre'),
  citta: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED),
  provincia: Yup.string()
    .nullable(true)
    .transform((value) => (value === '' ? null : value))
    .required(ValidationErrorMessages.REQUIRED)
    .max(2, 'Provincia deve essere la sigla di 2 lettere'),
  descrizione: Yup.string()
    .nullable(true)
    .max(600, 'La descrizione non può superare i 600 caratteri'),
  guidaProsit: Yup.boolean().nullable(true),
  note: Yup.string()
    .nullable(true)
    .max(120, 'Le note non possono superare 120 caratteri'),
  categorie: Yup.array()
    .of(
      Yup.object().shape({
        categoria: Yup.string()
          .nullable(true)
          .transform((value) => (value === '' ? null : value))
          .required(ValidationErrorMessages.REQUIRED),
        sottocategoria: Yup.string()
          .nullable(true)
          .transform((value) => (value === '' ? null : value))
          .required(ValidationErrorMessages.REQUIRED),
        scontoOnline: Yup.number()
          .typeError('Inserisci un valore numerico per lo sconto online')
          .min(0, 'Sconto non può essere negativo')
          .max(100, 'Sconto massimo 100%')
          .required(ValidationErrorMessages.REQUIRED),
        scontoNegozio: Yup.number()
          .typeError('Inserisci un valore numerico per lo sconto in negozio')
          .min(0, 'Sconto non può essere negativo')
          .max(100, 'Sconto massimo 100%')
          .required(ValidationErrorMessages.REQUIRED),
      })
    )
    .min(1, 'Almeno una categoria è richiesta')
    .max(5, 'Massimo 5 categorie'),
  socioOnav: Yup.boolean().nullable(true),
  numeroTessera: Yup.mixed().when('socioOnav', {
    is: true,
    then: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .typeError('Numero tessera deve essere un numero')
      .required('Numero tessera richiesto per soci ONAV'),
    otherwise: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .typeError('Numero tessera deve essere un numero')
      .nullable(true)
      .notRequired(),
  }),
  latitude: Yup.number()
    .typeError('Inserisci un valore numerico per la latitudine')
    .nullable(true)
    .min(-90, 'Latitudine deve essere tra -90 e 90')
    .max(90, 'Latitudine deve essere tra -90 e 90'),
  longitude: Yup.number()
    .typeError('Inserisci un valore numerico per la longitudine')
    .nullable(true)
    .min(-180, 'Longitudine deve essere tra -180 e 180')
    .max(180, 'Longitudine deve essere tra -180 e 180'),
});

export const fidelityRejectValidator = Yup.object().shape({
  note: Yup.string().required('È necessario specificare il motivo del rifiuto'),
});
